document.addEventListener('DOMContentLoaded', () => {
  const mediaWrapper = document.querySelectorAll('.media-wrapper-main');

  mediaWrapper.forEach(media => {
    const audio_controls = media.querySelector('.audio-controls');
    const videoElement = media.querySelector('video');

    if (audio_controls && videoElement) {
      const playSvg = audio_controls.querySelector('.play-svg');
      const pauseSvg = audio_controls.querySelector('.pause-svg');
      // setTimeout(() => {
      //   videoElement.muted = false;
      // }, 100);
      if (playSvg && pauseSvg) {
        audio_controls.addEventListener('click', () => {
          videoElement.muted = !videoElement.muted;

          playSvg.classList.toggle('hidden');
          pauseSvg.classList.toggle('hidden');
        });
      }
    }
  });
});
